export default __webpack_public_path__ + "1bd68453a2d52d0f703a289c90806bad.svg";